import React, { useEffect, useRef, useState } from "react";
import { TreeView, TreeItem } from "@mui/lab";
import Checkbox from "@mui/material/Checkbox";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box, Stack } from "@mui/material";

const TreeviewCheckbox = ({
  data: _data,
  value = { p: [], w: [], f: [] },
  onChange = () => {},
  selectedCheckboxes = [],
  onSelectCheckbox = () => {},
}) => {
  console.log({ _data23: _data });
  const data = {
    id: "p_1",
    label: "Project 1",
    children: [
      {
        id: "p_1-w_1",
        label: "Wing 1",
        children: [
          {
            id: "p_1-w_1-f_1",
            label: "Floor 1-1",
          },
          {
            id: "p_1-w_1-f_2",
            label: "Floor 1-2",
          },
          {
            id: "p_1-w_1-f_3",
            label: "Floor 1-3",
          },
        ],
      },
      {
        id: "p_1-w_2",
        label: "Wing 2",
        children: [
          {
            id: "p_1-w_2-f_1",
            label: "Floor 2-1",
          },
        ],
      },
    ],
  };
  // const [selected, setSelected] = useState([]);
  const [treeViewData, setTreeViewData] = useState([]);
  const ref = useRef(null);

  useEffect(() => {
    setTreeViewData(_data);
  }, []);

  console.log({ _projects: selectedCheckboxes });

  const handleCheckboxChange = (event, nodes) => {
    // if (nodes.children) alert("It have childrens");

    const nodeIds = nodes.id;
    let childrenIds = [];
    if (nodes.children)
      childrenIds = [
        ...nodes.children.map((c) => {
          let subChildrenIds = [c.id];
          if (c.children)
            subChildrenIds = [
              ...subChildrenIds,
              ...c.children.map((c) => c.id),
            ];
          return subChildrenIds;
        }),
      ];
    childrenIds = childrenIds.flat();
    console.clear();
    console.log({ childrenIds, selectedCheckboxes });
    let data = [];
    event.stopPropagation();
    console.log(8888888);
    if (selectedCheckboxes.includes(nodeIds)) {
      console.log(true);
      data = [
        ...selectedCheckboxes
          .filter((n) => n !== nodeIds)
          .filter((n) => !childrenIds.includes(n)),
      ];
      // setSelected(data);
      onSelectCheckbox(data);
    } else {
      data = [...selectedCheckboxes, nodeIds, ...childrenIds];
      // setSelected(data);
      onSelectCheckbox(data);
    }
    console.log(getParsedData(data));

    console.log(8888888);
    onChange(getParsedData(data));
  };

  const renderTree = (nodes) =>
    nodes ? (
      <TreeItem
        key={nodes.id}
        nodeId={nodes.id}
        label={
          <Stack direction="row" alignItems="center" spacing={1}>
            <Checkbox
              onClick={(e) => handleCheckboxChange(e, nodes)}
              checked={selectedCheckboxes.includes(nodes.id)}
              indeterminate={
                nodes.children?.some((child) =>
                  selectedCheckboxes.includes(child.id)
                ) && !selectedCheckboxes.includes(nodes.id)
              }
            />
            {/* {console.log({ nodes })} */}
            <span>{nodes?.label?.toUpperCase()}</span>
          </Stack>
        }
      >
        {Array.isArray(nodes.children)
          ? nodes.children.map((node) => renderTree(node))
          : null}
      </TreeItem>
    ) : null;
  // if (treeViewData.length)
  return (
    <Box
      sx={{
        "& *": {
          fontSize: "2rem !important",
        },
        "& span + span": {
          fontSize: "1.5rem !important",
        },
      }}
    >
      {treeViewData.map((t) => (
        <TreeView
          key={t.id}
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          onNodeToggle={() => {}}
          // onNodeSelect={handleCheckboxChange}
        >
          {renderTree(t)}
        </TreeView>
      ))}
    </Box>
  );
  // else return <>Loading...</>;
};

export default TreeviewCheckbox;

function parseProjectStr(str) {
  let obj = {};
  let arr = str.split("&").map((kv) => kv.split("="));
  arr.forEach(([key, value]) => {
    obj[key] = value;
  });
  return obj;
}

function getParsedData(data) {
  let result = { p: [], w: [], f: [] };

  data.forEach((str) => {
    const { p, w, f } = parseProjectStr(str);
    p && result.p.push(p);
    w && result.w.push(w);
    f && result.f.push(f);
  });

  return result;
}
